module.exports = __webpack_public_path__ + "ba343bb5f6d8c1596d4f3be019c82d8c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-ja.html
// module id = 1018
// module chunks = 0